import React from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { isBefore } from 'date-fns'

import {
  REACT_APP_FEATURE_FLAG_ABILITY_CERTIFICATE_PRIVATE,
  REACT_APP_FEATURE_FLAG_ABILITY_CERTIFICATE_PUBLIC,
  REACT_APP_FEATURE_FLAG_ABILITY_TAB,
  REACT_APP_FEATURE_FLAG_BUSINESS_ACTIVITIES_START_DATE,
  REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR,
  REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR_PRIVATE_TAB,
  REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR_PUBLIC,
  REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR_TAB,
  REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR_UTM_VALIDATION,
  REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR_V2,
  REACT_APP_FEATURE_FLAG_DOCUMENTS_FRAMEWORK,
  REACT_APP_FEATURE_FLAG_FINAL_BENEFICIARY_SECTION,
  REACT_APP_FEATURE_FLAG_GENERAL_INFORMATION_TAB,
  REACT_APP_FEATURE_FLAG_HISTORICAL_SANCTIONS,
  REACT_APP_FEATURE_FLAG_LEGAL_DOCUMENTS,
  REACT_APP_FEATURE_FLAG_PARTNERSHIP_SECTION,
  REACT_APP_FEATURE_FLAG_PAYMENT_WITHOUT_LOGIN,
  REACT_APP_FEATURE_FLAG_REASON_ANTIUNION_PRACTICES,
  REACT_APP_FEATURE_FLAG_RECALCULATE_ABILITY_SECTION,
  REACT_APP_FEATURE_FLAG_RELATED_COMPANY_SECTION,
  REACT_APP_FEATURE_FLAG_SHOW_PRIVATE_UNIQUE_SELLER,
  REACT_APP_FEATURE_FLAG_SHOW_PUBLIC_UNIQUE_SELLER,
  REACT_APP_FEATURE_FLAG_STAMP,
  REACT_APP_FEATURE_FLAG_SUMMARY_BUTTON_AFFIDAVIT_PRIVATE,
  REACT_APP_FEATURE_FLAG_SUMMARY_SECTION_PUBLIC,
  REACT_APP_FEATURE_FLAG_SUMMARY_SELLER_PDF_BUTTON,
  REACT_APP_FEATURE_FLAG_TAX_ANNOTATIONS,
  REACT_APP_FEATURE_FLAG_TECHNICAL_ACTIVITIES_START_DATE,
  REACT_APP_FEATURE_FLAG_TEMPORARY_UNIONS,
  REACT_APP_FEATURE_FLAG_TEMPORARY_UNIONS_TAB,
  REACT_APP_FEATURE_FLAG_USER_INFO,
  REACT_APP_FEATURE_FLAG_WORK_REGISTER,
  REACT_APP_FEATURE_LINK_TO_OPEN_CONTRACT_SELLER,
  REACT_APP_FEATURE_LINK_TO_OPEN_DATA_INFORMATION
} from '../../config/settings/environment'

const isFeatureEnabled = envVar => envVar === true || envVar === 'true'

const featureMap = {
  'com.seller/ability.certificate.private': REACT_APP_FEATURE_FLAG_ABILITY_CERTIFICATE_PRIVATE,
  'com.seller/ability.certificate.public': REACT_APP_FEATURE_FLAG_ABILITY_CERTIFICATE_PUBLIC,
  'com.seller/activity.start.date': REACT_APP_FEATURE_FLAG_BUSINESS_ACTIVITIES_START_DATE,
  'com.seller/button.affidavit.private': REACT_APP_FEATURE_FLAG_SUMMARY_BUTTON_AFFIDAVIT_PRIVATE,
  'com.seller/button.seller.pdf.private': REACT_APP_FEATURE_FLAG_SUMMARY_SELLER_PDF_BUTTON,
  'com.seller/contractual.behavior': REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR,
  'com.seller/contractual.behavior.public': REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR_PUBLIC,
  'com.seller/contractual.behavior.utm.validation': REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR_UTM_VALIDATION,
  'com.seller/contractual.behavior.v2': REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR_V2,
  'com.seller/documents.framework': REACT_APP_FEATURE_FLAG_DOCUMENTS_FRAMEWORK,
  'com.seller/final.beneficiary.section': REACT_APP_FEATURE_FLAG_FINAL_BENEFICIARY_SECTION,
  'com.seller/historical.sanctions': REACT_APP_FEATURE_FLAG_HISTORICAL_SANCTIONS,
  'com.seller/legal.documents': REACT_APP_FEATURE_FLAG_LEGAL_DOCUMENTS,
  'com.seller/link.to.open.contract.seller': REACT_APP_FEATURE_LINK_TO_OPEN_CONTRACT_SELLER,
  'com.seller/link.to.open.data.information': REACT_APP_FEATURE_LINK_TO_OPEN_DATA_INFORMATION,
  'com.seller/partnership.section': REACT_APP_FEATURE_FLAG_PARTNERSHIP_SECTION,
  'com.seller/payment.without.login': REACT_APP_FEATURE_FLAG_PAYMENT_WITHOUT_LOGIN,
  'com.seller/private.tab.contractual.behavior': REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR_PRIVATE_TAB,
  'com.seller/private.unique.seller': REACT_APP_FEATURE_FLAG_SHOW_PRIVATE_UNIQUE_SELLER,
  'com.seller/public.unique.seller': REACT_APP_FEATURE_FLAG_SHOW_PUBLIC_UNIQUE_SELLER,
  'com.seller/recalculate.ability.button': REACT_APP_FEATURE_FLAG_RECALCULATE_ABILITY_SECTION,
  'com.seller/related.company.section': REACT_APP_FEATURE_FLAG_RELATED_COMPANY_SECTION,
  'com.seller/stamp': REACT_APP_FEATURE_FLAG_STAMP,
  'com.seller/summary.section.public': REACT_APP_FEATURE_FLAG_SUMMARY_SECTION_PUBLIC,
  'com.seller/tab.ability': REACT_APP_FEATURE_FLAG_ABILITY_TAB,
  'com.seller/tab.contractual.behavior': REACT_APP_FEATURE_FLAG_CONTRACTUAL_BEHAVIOR_TAB,
  'com.seller/tab.general.information': REACT_APP_FEATURE_FLAG_GENERAL_INFORMATION_TAB,
  'com.seller/tab.temporary.unions': REACT_APP_FEATURE_FLAG_TEMPORARY_UNIONS_TAB,
  'com.seller/tax.annotations': REACT_APP_FEATURE_FLAG_TAX_ANNOTATIONS,
  'com.seller/technical.activity.start.date': REACT_APP_FEATURE_FLAG_TECHNICAL_ACTIVITIES_START_DATE,
  'com.seller/temporary.unions': REACT_APP_FEATURE_FLAG_TEMPORARY_UNIONS,
  'com.seller/user.info.visible': REACT_APP_FEATURE_FLAG_USER_INFO,
  'com.seller/work.register.visible': REACT_APP_FEATURE_FLAG_WORK_REGISTER
}

const specialFeatures = {
  'com.seller/antiunion.practices.not.visible': !isBefore(
    new Date(REACT_APP_FEATURE_FLAG_REASON_ANTIUNION_PRACTICES),
    new Date()
  ),
  'com.seller/antiunion.practices.visible': isBefore(
    new Date(REACT_APP_FEATURE_FLAG_REASON_ANTIUNION_PRACTICES),
    new Date()
  )
}

/**
 * The ProtectByFeatures component.
 */
const ProtectByFeatures = props => {
  const { children, fallback, redirectTo, rule } = props

  const navigate = useNavigate()

  const features = Object.fromEntries(Object.entries(featureMap).map(([key, value]) => [key, isFeatureEnabled(value)]))
  Object.assign(features, specialFeatures)

  const result = rule(features)

  if (!result && redirectTo) {
    navigate(redirectTo)
  }

  if (!result) {
    return fallback(features)
  }

  return <>{children}</>
}

ProtectByFeatures.defaultProps = {
  fallback: () => null,
  redirectTo: '',
  rule: () => true
}

ProtectByFeatures.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.func,
  redirectTo: PropTypes.string,
  rule: PropTypes.func
}

export default ProtectByFeatures
